<template>
  <div class="contact container">
    <h1>联系方式</h1>
    <br />
    <p>实验室地点：9#305</p>
    <p>联系负责老师: 吴老师（9#401）</p>
    <p></p>
    <p>软件孵化实验室</p>
    <p>2019.11.1</p>
    <hr />
    <p>报名系统问题或网站故障联系：</p>
    <p>qq：501966782</p>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact {
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue